import { isIsoDate } from '../validation/is-iso-date.function';
import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import type { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Returns the ISO 8601 weekday number for the given ISO input.
 * - Monday = 1, Tuesday = 2, ..., Sunday = 7
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Calculation uses UTC and only the calendar date portion (YYYY-MM-DD) for determinism.
 */
export function getIsoWeekday(input: IsoDate | IsoDateTime | IsoDateTimeTz): number {
  const { year, month, day } = deconstructDate(input);
  if (!year || !month || !day)
    throw new Error('getIsoWeekday: invalid ISO date/date-time string');

  const date = new Date(Date.UTC(year, month - 1, day));
  const dow = date.getUTCDay(); // 0=Sun..6=Sat
  // Convert to ISO weekday: Mon=1..Sun=7
  return ((dow + 6) % 7) + 1;
}

